import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const GameMarqueeIconButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={onClick}
      minW="40px"
      minH="30px"
      maxH="30px"
      opacity={"0.3"}
      _hover={{
        opacity: "1",
      }}
      fontSize="sm"
      colorScheme="blue"
      aria-label="遊戲公告"
      boxShadow="md"
    >
      {t("common.遊戲公告")}
    </Button>
  );
};

export default GameMarqueeIconButton;
